import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import Swal from "sweetalert2";

class WhyShopOnlineWithUs extends Component {
  state = {
    user_id: localStorage.getItem("user_id"),
    page_type: this.props.page_type || "WhyShopOnlinewithUs",

    title: "",
    description: "",
    loading: false,
  };

  /** =====================================================
   *  API BASE URL (IMPORTANT)
   * ===================================================== */
  API_BASE = axios.defaults.baseURL;

  componentDidMount() {
    this.fetchExistingData();
  }

  /** =====================================================
   *  FETCH EXISTING DATA
   * ===================================================== */
  fetchExistingData = async () => {
    const { user_id, page_type } = this.state;

    if (!user_id || !page_type) return;

    try {
      this.setState({ loading: true });

      const res = await axios.get("/additional_pages", {
        params: { user_id, page_type },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      const d = res?.data?.data;
      if (d) {
        this.setState({
          title: d.title || "",
          description: d.description || "",
        });
      }
    } catch (error) {
      console.error("Fetch Error:", error);
    } finally {
      this.setState({ loading: false });
    }
  };

  /** =====================================================
   *  HANDLE INPUT CHANGE
   * ===================================================== */
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  /** =====================================================
   *  SAVE / UPDATE
   * ===================================================== */
  handleSubmit = async (e) => {
    e.preventDefault();

    const { user_id, page_type, title, description } = this.state;

    if (!user_id || !page_type) {
      Swal.fire("Error", "User ID or page type missing", "error");
      return;
    }

    try {
      this.setState({ loading: true });

      const formData = new FormData();
      formData.append("user_id", user_id);
      formData.append("page_type", page_type);
      formData.append("title", title);
      formData.append("description", description);

      const res = await axios.post("/additional_pages", formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      Swal.fire("Success", res.data.message, "success");

      this.fetchExistingData();
    } catch (error) {
      console.error(error);
      Swal.fire(
        "Error",
        error.response?.data?.message || "Something went wrong",
        "error"
      );
    } finally {
      this.setState({ loading: false });
    }
  };

  /** =====================================================
   *  RENDER UI
   * ===================================================== */
  render() {
    const { title, description, loading } = this.state;

    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="row">
            <div className="col-12">
              <div className="card shadow-sm border-0 rounded-4">
                <div className="card-header">
                  <h4 className="mb-0">Additional Page</h4>
                </div>

                <div className="card-body p-4">
                  <form onSubmit={this.handleSubmit}>
                    <div className="row g-3">

                      {/* Title */}
                      <div className="col-md-12">
                        <label className="form-label">Title</label>
                        <input
                          type="text"
                          name="title"
                          className="form-control"
                          value={title}
                          onChange={this.handleChange}
                          required
                        />
                      </div>

                      {/* Description */}
                      <div className="col-md-12">
                        <label className="form-label">Description</label>
                        <textarea
                          name="description"
                          className="form-control"
                          rows="3"
                          value={description}
                          onChange={this.handleChange}
                        ></textarea>
                      </div>

                    </div>

                    <div className="text-end mt-4">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? "Saving..." : "Save"}
                      </button>
                    </div>
                  </form>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default WhyShopOnlineWithUs;
